<template>
  <Slideover :visible="visible">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="$emit('toggle-slideover')"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>

    <!-- Main -->
    <div class="flex flex-col py-3 px-2 mx-4 space-y-3">
      <div class="w-full flex space-x-2">
        <div class="w-1/2">
          <label
            :for="`payment_method_${_uid}`"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Payment Method:
          </label>
          <input
            v-model="paymentMethod"
            disabled
            type="text"
            :id="`payment_method_${_uid}`"
            class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5 disabled:text-gray-500 disabled:cursor-not-allowed"
          />
        </div>
        <div class="w-1/2">
          <label
            :for="`transaction_id_${_uid}`"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Transaction ID:
          </label>
          <input
            v-model="transactionId"
            disabled
            type="text"
            :id="`transaction_id_${_uid}`"
            class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5 disabled:text-gray-500 disabled:cursor-not-allowed"
          />
        </div>
      </div>
      <div class="w-full flex space-x-2">
        <div class="w-full">
          <label
            :for="`amount_{_uid}`"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Refund Amount:
          </label>
          <input
            :value="amount"
            @change="amount = null; amount = decimal($event.target.value)"
            type="number"
            step="0.01"
            :id="`amount_{_uid}`"
            class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          />
        </div>
      </div>
      <div class="w-full flex space-x-2">
        <div class="w-full">
          <label
            :for="`notes_{_uid}`"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Notes:
          </label>
          <textarea
            v-model="notes"
            :id="`notes_{_uid}`"
            class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          ></textarea>
        </div>
      </div>

    </div>

    <HttpError :error="error" dismissable />

    <!-- Footer -->
    <div class="flex justify-end px-4 py-4 space-x-4">
      <span class="inline-flex rounded-md shadow-sm">
        <Button
          @click-handler="$emit('toggle-slideover')"
          :disabled="processing"
          class="btn btn-white"
        >
          Cancel
        </Button>
      </span>
      <span class="inline-flex rounded-md shadow-sm">
        <Button
          @click-handler="process"
          :disabled="! canProcess || processing"
          class="flex items-center space-x-2"
        >
          <span>Refund</span>
          <LoadingSpinner v-if="processing" class="text-white" />
        </Button>
      </span>
    </div>

  </Slideover>
</template>
<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const Transactions = ApiFactory.get('transactions');

export default {
  name: "RefundTransaction",
  components: {
    Button,
    Slideover,
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    visible: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      paymentMethod: null,
      transactionId: null,
      amount: null,
      notes: null,
      error: null,
      processing: false
    }
  },
  computed: {
    canProcess() {
      if (! this.paymentMethod) {
        return false;
      }

      if (! this.amount) {
        return false;
      }

      return true;
    },
  },
  watch: {
    transaction() {
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.paymentMethod = this.transaction?.Type;
      this.transactionId = this.transaction?.ApprovalCode;
      this.amount = this.decimal(this.transaction?.Amount, 2);
      this.notes = this.transaction?.Notes;
    },
    decimal(value, digits) {
      if (digits == undefined) {
        digits = 2;
      }

      return Number(value).toFixed(digits);
    },
    process() {
      this.processing = true;

      Transactions.refund(
          this.transaction.AutoNumber,
          {
            Amount: this.amount,
            Notes: this.notes,
          }
        )
        .then(this.handleSuccess)
        .catch((error) => this.error = error)
        .finally(() => this.processing = false)
    },
    handleSuccess() { 
      this.$emit('toggle-slideover');
      this.$emit('refresh-order');
    }
  }
};
</script>
